// extracted by mini-css-extract-plugin
export default {"root":"Sider_root__Z2yFR","drawer":"Sider_drawer__BRF+J","title":"Sider_title__CIJF5","versionwrapper":"Sider_versionwrapper__EBL+9","version":"Sider_version__GVlpk"};